import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import axios from 'services/axios'
import { selectCurrentZone } from 'store/global'
import { CurrentZone } from 'utils/types'
import { convertToYearMonth } from './utils'

interface IDateRange {
  minDate: string
  maxDate: string
}

const useDateRangeValues = () => {
  const { entityId } = useParams<{ entityId: string }>()
  const currentZone: CurrentZone = useSelector(selectCurrentZone)

  const [range, setRange] = useState<IDateRange | null>(null)

  useEffect(() => {
    axios
      .get(`crypto/activity-date-range/${entityId}`, {
        params: {
          zone: currentZone.cryptoActivityIndices,
        },
      })
      .then(res => setRange(res.data as IDateRange))
      .catch(err => console.error(err))
  }, [currentZone.cryptoActivityIndices, entityId])

  return {
    range,
    yearMonthRange: range
      ? {
          maxDate: convertToYearMonth(range.maxDate),
          minDate: convertToYearMonth(range.minDate),
        }
      : null,
  }
}

export default useDateRangeValues
